/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Filter_Price_MinInputs */

const cs_filter_price_min = /** @type {(inputs: Filter_Price_MinInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cena od`)
};

const en_filter_price_min = /** @type {(inputs: Filter_Price_MinInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Price from`)
};

/**
* | output |
* | --- |
* | "Price from" |
*
* @param {Filter_Price_MinInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const filter_price_min = /** @type {((inputs?: Filter_Price_MinInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Filter_Price_MinInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_filter_price_min(inputs)
	return cs_filter_price_min(inputs)
});